module.exports = __webpack_public_path__ + "static/media/klader.160f1da2.svg";